import React, { useRef, useState, useEffect } from 'react';
import CHOPHeader from "./CHOPHeader";
import PicuHeader from "./PicuHeader";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import CircleCheckedFilled from '@mui/icons-material/CheckCircle';
import CircleUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import '../css/Timeout.css';
import saveData from '../services/saveData';
import getObservationEncounterData from '../services/getObservationEncounterData';
import WriteToLog from '../services/WriteToLog';
import axios from "axios";
import getRiskFactor from "../services/getRiskFactor";
import getAAOModelPrediction from '../services/getAAOModelPrediction';
import roundToTwoDecimalsIfNeeded from '../services/roundToTwoDecimalsIfNeeded';

const Timeout = () => {
  const title = "Timeout";
  const note = "";
  const navigate = useNavigate();

  const [helperErrorText, setHelperErrorText] = React.useState('');
  const location = useLocation();
  const { selectedPatient } = location.state;

  const banner = selectedPatient.need_patient_banner;
  const room = selectedPatient.ROOM + " " + selectedPatient.BED;
  const name = selectedPatient.DISPLAY_NAME;
  const mrn = selectedPatient.MRN;
  const dob = selectedPatient.DOB;
  const gender = selectedPatient.gender;
  const age = selectedPatient.DISPLAY_AGE;
  const planLink = <NavLink to="/assessment" className='list-link' state={{ selectedPatient: selectedPatient }}>Plan</NavLink>

  const [RIGHT_PROTECTION, setProtectionValue] = React.useState('');
  const handleProtection = (event) => {
    if (event.target.checked) {
      setProtectionValue(event.target.value);
    } else {
      setProtectionValue('');    
    }
  };

  const [RIGHT_PATIENT, setPatientValue] = React.useState('');
  const handlePatient= (event) => {
    if (event.target.checked) {
      setPatientValue(event.target.value);
    } else {
      setPatientValue('');    
    }
  };

  const [RIGHT_PLAN, setPlanValue] = React.useState('');
  const handlePlan = (event) => {
    if (event.target.checked) {
      setPlanValue(event.target.value);
    } else {
      setPlanValue('');    
    }
  };

  const [RIGHT_PREP, setPrepValue] = React.useState('');
  const handlePrep = (event) => {
    if (event.target.checked) {
      setPrepValue(event.target.value);
    } else {
      setPrepValue('');    
    }
  };

  const [RIGHT_EQUIPMENT, setEquipmentValue] = React.useState('');
  const handleEquipment = (event) => {
    if (event.target.checked) {
      setEquipmentValue(event.target.value);
    } else {
      setEquipmentValue('');    
    }
  };

  const [RIGHT_MONITORING, setMonitoringValue] = React.useState('');
  const handleMonitoring = (event) => {
    if (event.target.checked) {
      setMonitoringValue(event.target.value);
    } else {
      setMonitoringValue('');    
    }
  };

  const [RIGHT_RESCUE_PLAN, setRescuePlanValue] = React.useState('');
  const handleRescuePlan = (event) => {
    if (event.target.checked) {
      setRescuePlanValue(event.target.value);
    } else {
      setRescuePlanValue('');    
    }
  };

  const [RIGHT_ATTITUDE, setAttitudeValue] = React.useState('');
  const handleAttitude = (event) => {
    if (event.target.checked) {
      setAttitudeValue(event.target.value);
    } else {
      setAttitudeValue('');    
    }
  };

  const [showGreenDiv, setShowGreenDiv] = useState(false);
  const [progressIndicator, setProgressIndicator] = React.useState(true);
  const [predictionRisk, setPredictionRisk] = React.useState('');
  const [riskFactors, setRiskFactors] = React.useState();

  /* Get Latest Timeout data if any in Epic */
  useEffect(() => {  
    async function fetchData() {
      if (selectedPatient.patFHIRID && selectedPatient.CSN && selectedPatient.CSN !== '99999') {
        const ehrconfig = await axios.get('ehrconfig.json');
        let riskGroup = ehrconfig.data["RISK_GROUP_VALUE"];

        // Get Risk Prediction data from EHR
        const predictionResponse = await getObservationEncounterData(selectedPatient.patFHIRID, selectedPatient.encFHIRID, selectedPatient.riskModel, selectedPatient.fhir_server, selectedPatient.access_token);
        WriteToLog("getObservationEncounterData Prediction response: " + JSON.stringify(predictionResponse));
        if(predictionResponse) {
          const predictionResponseJson = JSON.parse(predictionResponse);
          let isLessThanFiveMinutes = false;

          if (predictionResponseJson && predictionResponseJson.request) {
            const predictionResponseDate = new Date(predictionResponseJson.request.message_creation_time);
            //console.log(predictionResponseDate);
            const currentDate = new Date();
            //console.log(currentDate);
            const timeDifferenceMs = Math.abs(currentDate.getTime() - predictionResponseDate.getTime());
            const fiveMinutesInMs = 5 * 60 * 1000;
            isLessThanFiveMinutes = timeDifferenceMs < fiveMinutesInMs;
            //console.log(isLessThanFiveMinutes);
          }

          if (isLessThanFiveMinutes) {
            // Use existing Risk Prediction
            const predictionValue = predictionResponseJson.output;
            // Note: Low < 0.11, medium 0.11-<0.22, high >0.22
            if (predictionValue.output && predictionValue.output.length > 0) {
              let riskNumber = Number(predictionValue.output[0].risk);
              if (riskNumber >= 0.11 && riskNumber <= 0.22) {
                setPredictionRisk('medium');
              }
              if (riskNumber > 0.22) {
                setPredictionRisk('high');
              }
              if (predictionValue.output[0].top_risk_factors.length > 0) {
                let topRiskFactors = predictionValue.output[0].top_risk_factors;
                let riskDisplayValues = [];

                for (var i= 0; i < topRiskFactors.length; i++) {
                  if (topRiskFactors[i].direction === "positive") {
                    let var_name = topRiskFactors[i].var_name;
                    let var_value = topRiskFactors[i].var_value;
                    let displayName = "";
                    for (const [key, valueArray] of Object.entries(riskGroup)) {
                      if (Array.isArray(valueArray) && valueArray.includes(var_name)) {          
                        if (typeof var_value === "number") {
                          if (var_name.includes("Age")) {
                            displayName = key + " : " + selectedPatient.DISPLAY_AGE;
                          } else {
                            displayName = key + " : " + roundToTwoDecimalsIfNeeded(var_value);
                          }
                          if (!riskDisplayValues.some(k => k.includes(key + " : ")) && riskDisplayValues.length < 3) {
                            riskDisplayValues.push(displayName);
                          }
                        } else {
                          displayName = key;
                          if (!riskDisplayValues.some(k => k.includes(key)) && riskDisplayValues.length < 3) {
                            riskDisplayValues.push(displayName);
                          }
                        }
                      }
                    }           
                  }
                }
                WriteToLog("Timeout Page - existing predictionValues to display: " + riskDisplayValues);
                setRiskFactors(riskDisplayValues);
              }
            }
            setProgressIndicator(false);
          } else {
            // Clinical Decision Support - Get Risk Factor (Real Time Risk Prediction)
            const riskResponse = await getRiskFactor(selectedPatient.patFHIRID, selectedPatient.CSN, selectedPatient.MRN, selectedPatient.fhir_server, selectedPatient.access_token);
            if (riskResponse) {
              setProgressIndicator(true);
              WriteToLog("Timeout Page - getRiskFactor response: " + JSON.stringify(riskResponse)); 

              var date = new Date();
              const currentdatetime = date.toISOString().slice(0, 19) + 'Z';

              // Build JSON data
              let patientJSON = {};
              patientJSON.message_creation_time = currentdatetime;
              patientJSON.patient_id = selectedPatient.PATIENT_ID;
              let demographics = {};
              demographics.DOB = dob;
              demographics.gender = gender;
              patientJSON.demographics = demographics;
              let adt = {};
              adt.icu_admission_time = selectedPatient.AdmitDate;
              patientJSON.adt = adt;
              let problem_list = {};
              problem_list.difficult_airway = {};
              if (riskResponse.Conditions) {
                if (riskResponse.Conditions.length > 0) {
                  problem_list.difficult_airway.diagnoses = riskResponse.Conditions;
                } 
              } else {
                problem_list.difficult_airway.diagnoses = [];
              }
              patientJSON.problem_list = problem_list;
              
              let flowsheet = {};
              flowsheet.resp = {};

              if (riskResponse.BiPAPSet) {
                flowsheet.resp.peak_inspiratory_pressure_set = riskResponse.BiPAPSet; // Flowsheet ID 40010946
              } else {
                flowsheet.resp.peak_inspiratory_pressure_set = {};
                flowsheet.resp.peak_inspiratory_pressure_set.value = null;
                flowsheet.resp.peak_inspiratory_pressure_set.timestamp = null;
              }
              if (riskResponse.BiPAP){
                flowsheet.resp.peak_inspiratory_pressure_actual = riskResponse.BiPAP; // Flowsheet ID 40000699
              } else {
                flowsheet.resp.peak_inspiratory_pressure_actual = {};
                flowsheet.resp.peak_inspiratory_pressure_actual.value = null;
                flowsheet.resp.peak_inspiratory_pressure_actual.timestamp = null;
              }
              if (riskResponse.CPAPSet) {
                flowsheet.resp.peep_set = riskResponse.CPAPSet; // Flowsheet ID 40000566
              } else {
                flowsheet.resp.peep_set = {};
                flowsheet.resp.peep_set.value = null;
                flowsheet.resp.peep_set.timestamp = null;
              }
              if (riskResponse.CPAP) {
                flowsheet.resp.peep_actual = riskResponse.CPAP; // Flowsheet ID 4000010947
              } else {
                flowsheet.resp.peep_actual = {};
                flowsheet.resp.peep_actual.value = null;
                flowsheet.resp.peep_actual.timestamp = null;
              }
              if (riskResponse.FiO2) {
                flowsheet.resp.fio2 = riskResponse.FiO2; // Flowsheet ID 40002468
              } else {
                flowsheet.resp.fio2 = {};
                flowsheet.resp.fio2.value = null;
                flowsheet.resp.fio2.timestamp = null;
              }

              if (riskResponse.FlowRate) {
                flowsheet.resp.hfnc = riskResponse.FlowRate;
              } else {
                flowsheet.resp.hfnc = {};
                flowsheet.resp.hfnc.value = null;
                flowsheet.resp.hfnc.timestamp = null;
              }

              flowsheet.vital_signs = {};
              if (riskResponse.SpO2) {
                flowsheet.vital_signs.spo2 = riskResponse.SpO2;
              } else {
                flowsheet.vital_signs.spo2 = null;
              }
              if (riskResponse.HeartRate) {
                flowsheet.vital_signs.heart_rate = riskResponse.HeartRate;
              } else {
                flowsheet.vital_signs.heart_rate = null;
              }
              if (riskResponse.art) {
                flowsheet.vital_signs.map_art = riskResponse.art; // Flowsheet ID 400700102
              } else {
                flowsheet.vital_signs.map_art = null;
              }
              if (riskResponse.cuff) {
                flowsheet.vital_signs.map_cuff = riskResponse.cuff; // Flowsheet ID 40000675
              } else {
                flowsheet.vital_signs.map_cuff = null;
              }
              if (riskResponse.BP) {
                flowsheet.vital_signs.systolic_bp = riskResponse.BP;
              } else {
                flowsheet.vital_signs.systolic_bp = null;
              }
              if (riskResponse.Diastolic) {
                flowsheet.vital_signs.diastolic_bp = riskResponse.Diastolic;
              } else {
                flowsheet.vital_signs.diastolic_bp = null;
              }
              if (riskResponse.Temp) {
                flowsheet.vital_signs.temperature = riskResponse.Temp; 
              } else {
                flowsheet.vital_signs.temperature = null; 
              }
              
              flowsheet.obesity = {};
              if (riskResponse.Weight) {
                flowsheet.obesity.timestamp = riskResponse.Weight.timestamp;
                flowsheet.obesity.weight_kg = riskResponse.Weight;
                delete flowsheet.obesity.weight_kg["timestamp"];
              } else {
                flowsheet.obesity.timestamp = null;
                flowsheet.obesity.weight_kg = null;
              }
              patientJSON.flowsheet = flowsheet;

              let mar = {};
              if (riskResponse.Orders) {
                mar.Orders = riskResponse.Orders;
              } else {
                mar.Orders = [];
              }
              patientJSON.mar = mar;     
              patientJSON.lab = riskResponse.labs;

              //console.log("Patient JSON: " + JSON.stringify(patientJSON));
              const predictionValue = await getAAOModelPrediction(patientJSON);
              if (predictionValue) {
                //console.log("AAO Model Prediction Value: " + JSON.stringify(predictionValue));
                // Save AAO Prediction Model data to EHR
                let modelValue = JSON.stringify({request: patientJSON, output: predictionValue});
                let saveResponse = await saveData(selectedPatient.PATIENT_ID, selectedPatient.CSN, selectedPatient.riskModel, modelValue, selectedPatient.USER_ID, selectedPatient.fhir_server, selectedPatient.access_token);
                if (saveResponse === "success") {
                  WriteToLog('Timeout Page - AAO Model Prediction data saved successfully for patient: ' + selectedPatient.PATIENT_ID); 
                }

                // Note: Low < 0.11, medium 0.11-<0.22, high >0.22
                if (predictionValue.output && predictionValue.output.length > 0) {
                  let riskNumber = Number(predictionValue.output[0].risk);
                  if (riskNumber >= 0.11 && riskNumber <= 0.22) {
                    setPredictionRisk('medium');
                  }
                  if (riskNumber > 0.22) {
                    setPredictionRisk('high');
                  }
                  if (predictionValue.output[0].top_risk_factors.length > 0) {
                    let topRiskFactors = predictionValue.output[0].top_risk_factors;
                    let riskDisplayValues = [];

                    for (var j= 0; j < topRiskFactors.length; j++) {
                      if (topRiskFactors[j].direction === "positive") {
                        let var_name = topRiskFactors[j].var_name;
                        let var_value = topRiskFactors[j].var_value;
                        let displayName = "";
                        for (const [key, valueArray] of Object.entries(riskGroup)) {
                          if (Array.isArray(valueArray) && valueArray.includes(var_name)) {          
                            if (typeof var_value === "number") {
                              if (var_name.includes("Age")) {
                                displayName = key + " : " + selectedPatient.DISPLAY_AGE;
                              } else {
                                displayName = key + " : " + roundToTwoDecimalsIfNeeded(var_value);
                              }
                              if (!riskDisplayValues.some(k => k.includes(key + " : ")) && riskDisplayValues.length < 3) {
                                riskDisplayValues.push(displayName);
                              }
                            } else {
                              displayName = key;
                              if (!riskDisplayValues.some(k => k.includes(key)) && riskDisplayValues.length < 3) {
                                riskDisplayValues.push(displayName);
                              }
                            }
                          }
                        }           
                      }
                    }
                    WriteToLog("Timeout Page - predictionValues to display: " + riskDisplayValues);
                    setRiskFactors(riskDisplayValues);
                  }
                }
                setProgressIndicator(false);
              }
            }
          }
        } else {
          setProgressIndicator(false);
          // Display Model Prediction Not Available message
          setPredictionRisk('unavailable');
        }

        // Get Debrief data from EHR
        const debriefResponse = await getObservationEncounterData(selectedPatient.patFHIRID, selectedPatient.encFHIRID, selectedPatient.debriefId, selectedPatient.fhir_server, selectedPatient.access_token);
        //WriteToLog("getObservationEncounterData Debrief response: " + JSON.stringify(debriefResponse)); 

        // Get Timeout data from timeoutId
        const timeoutResponse = await getObservationEncounterData(selectedPatient.patFHIRID, selectedPatient.encFHIRID, selectedPatient.timeoutId, selectedPatient.fhir_server, selectedPatient.access_token);
        //WriteToLog("getObservationEncounterData TimeoutId response: " + JSON.stringify(timeoutResponse)); 
        var today = new Date();
        var currentdt = today.getFullYear() + '-' + ("0"+(today.getMonth()+1)).slice(-2) + '-' + ("0"+today.getDate()).slice(-2) + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        let currentdatetime = new Date(currentdt);
  
        if (timeoutResponse && timeoutResponse !== "") {
          var json = JSON.parse(timeoutResponse);
          let createDateTime = new Date(json.CREATE_DATETIME);
          const diff = Math.abs(currentdatetime - createDateTime);
          var minutes = Math.floor((diff/1000)/60);

          if (minutes <= 60 && debriefResponse === "") {  // debrief within 60 mins check
            //WriteToLog("time diff: " + minutes);
            setProtectionValue(json.RIGHT_PROTECTION); 
            setPatientValue(json.RIGHT_PATIENT);
            setPlanValue(json.RIGHT_PLAN);
            setPrepValue(json.RIGHT_PREP);
            setEquipmentValue(json.RIGHT_EQUIPMENT);
            setMonitoringValue(json.RIGHT_MONITORING);
            setRescuePlanValue(json.RIGHT_RESCUE_PLAN);
            setAttitudeValue(json.RIGHT_ATTITUDE); 
  
            if(json.RIGHT_PROTECTION !== '' && json.RIGHT_PATIENT !== '' && json.RIGHT_PLAN !== '' && json.RIGHT_PREP !== '' && json.RIGHT_EQUIPMENT !== '' && json.RIGHT_MONITORING !== '' && json.RIGHT_RESCUE_PLAN !== '' && json.RIGHT_ATTITUDE !== '') {
              // All Checklist Complete, route to Debrief Page
              navigate('/debrief', { state: { selectedPatient : selectedPatient } });
            } 
          }
        }
      } // end of if patFHIRID and CSN
    }
    fetchData();
  }, [dob, gender, navigate, selectedPatient]);

  /* Save Timeout form */
  const planForm = useRef();

  const handleSubmit = async(e) => {
    e.preventDefault();
    e.stopPropagation();

    const data = {RIGHT_PROTECTION,RIGHT_PATIENT,RIGHT_PLAN,RIGHT_PREP,RIGHT_EQUIPMENT,RIGHT_MONITORING,RIGHT_RESCUE_PLAN,RIGHT_ATTITUDE};
    if(data.RIGHT_PROTECTION === '' && data.RIGHT_PATIENT === '' && data.RIGHT_PLAN === '' && data.RIGHT_PREP === '' && data.RIGHT_EQUIPMENT === '' && data.RIGHT_MONITORING === '' && data.RIGHT_RESCUE_PLAN === '' && data.RIGHT_ATTITUDE === '') {
      // None selected, throw error
      setHelperErrorText('Please select a checklist');
    } else {
      setHelperErrorText('');
      // Save Timeout data
      var today = new Date();
      var currentdatetime = today.getFullYear() + '-' + ("0"+(today.getMonth()+1)).slice(-2) + '-' + ("0"+today.getDate()).slice(-2) + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
      data.CREATE_DATETIME = currentdatetime;
  
      if (selectedPatient.CSN && selectedPatient.CSN !== '99999') { // admitted
        /* Save Timeout data to EHR */
        let ehrValue = JSON.stringify(data);
        let ehrResponse = await saveData(selectedPatient.PATIENT_ID, selectedPatient.CSN, selectedPatient.timeoutId, ehrValue, selectedPatient.USER_ID, selectedPatient.fhir_server, selectedPatient.access_token);
        if (ehrResponse === "success") {    
          WriteToLog('Timeout saved successfully for patient: ' + selectedPatient.PATIENT_ID);
          setShowGreenDiv(true);
          if(data.RIGHT_PROTECTION !== '' && data.RIGHT_PATIENT !== '' && data.RIGHT_PLAN !== '' && data.RIGHT_PREP !== '' && data.RIGHT_EQUIPMENT !== '' && data.RIGHT_MONITORING !== '' && data.RIGHT_RESCUE_PLAN !== '' && data.RIGHT_ATTITUDE !== '') {
            // All Checklist Complete, route to Debrief Page
            navigate('/debrief', { state: { selectedPatient : selectedPatient } });
          }
        } else {
          setShowGreenDiv(false);
          WriteToLog("Timeout not saved to Epic for patient: " + selectedPatient.PATIENT_ID + " ehrResponse " + ehrResponse);
          navigate('/error', { state: { selectedPatient : selectedPatient, failure: "trying to save Timeout into Epic" } });
        }  
      } else { // non-admitted
        WriteToLog("NON-ADMITTED: Trying to save Timeout into Epic for non-admitted patient. This workflow is not supported.");
        navigate('/error', { state: { selectedPatient : selectedPatient, failure: "trying to save Timeout into Epic for non-admitted patient. This workflow is not supported" } });
      }
    }
  };

  return (
    <div className="Timeout">
      <CHOPHeader planLink={planLink} />
      <PicuHeader banner={banner} room={room} name={name} mrn={mrn} dob={dob} age={age} gender={gender} title={title} note={note} />

      <form onSubmit={handleSubmit} ref={planForm}>
      <div className="timeout-form">

      <div className="two-column">
        <div className="column1">
          <Checkbox 
          icon={<CircleUnchecked />}
          checkedIcon={<CircleCheckedFilled />}
          style={{ transform: "scale(1.75)", color: "#41B6E6", stroke: "#efefef", strokeWidth: "1" }}
          checked={RIGHT_PLAN === 'Y'} value="Y" onChange={handlePlan}
          />
          <span className="timeout-heading">Right Plan</span>
          <p>Review risk assessment and intubation plan</p>
        </div>
        {selectedPatient.PLAN_STATUS  === 'Plan Complete' && (
          <div className="column2"><Link to="/assessment" className="plan-link-blue" state={{ selectedPatient: selectedPatient }}>Go to Plan</Link></div>
        )}
      </div>
      {progressIndicator && <p className='progress-indicator'>Please wait, processing...</p>}
      {(predictionRisk === "medium") && (
        <div class="assessment-div">
        <h3>Risk Prediction</h3>
          <div class="risk-div">
            <div class="risk-table">
              <div class="medium-risk">
                <h4>MEDIUM RISK</h4>
                <p>Risk of Adverse Airway Outcome (TIAE or severe desaturation)</p>
              </div>
              <div class="risks">
                <div>
                  <h4>TOP 3 RISK FACTORS</h4>
                  <ul>
                    {riskFactors.map((item, i) => (
                    <li>{item}</li>
                    ))}
                  </ul>
                </div>  
              </div>
            </div>
          </div>
        </div>
      )}
      {(predictionRisk === "high") && (
        <div class="assessment-div">
        <h3>Risk Prediction</h3>
          <div class="risk-div">
            <div class="risk-table">
              <div class="high-risk">
                <h4>HIGH RISK</h4>
                <p>Risk of Adverse Airway Outcome (TIAE or severe desaturation)</p>
              </div>
              <div class="risks">
                <div>
                  <h4>TOP 3 RISK FACTORS</h4>
                  <ul>
                    {riskFactors.map((item, i) => (
                    <li>{item}</li>
                    ))}
                  </ul>
                </div>  
              </div>
            </div>
          </div>
        </div>
      )}
      {(predictionRisk === "unavailable") && (
        <div class="assessment-div">
        <h4>Risk Prediction not available at this point</h4>
        </div>
      )}
      <hr/>

      <Checkbox
      icon={<CircleUnchecked />}
      checkedIcon={<CircleCheckedFilled />}
      style={{ transform: "scale(1.75)", color: "#41B6E6", stroke: "#efefef", strokeWidth: "1" }}
      checked={RIGHT_PROTECTION === 'Y'} value="Y" onChange={handleProtection}
      />
      <span className="timeout-heading">Right Protection</span>
      <p>Confirm appropriate PPE including eye protection on all staff in the room</p>
      <hr/>

      <Checkbox
      icon={<CircleUnchecked />}
      checkedIcon={<CircleCheckedFilled />}
      style={{ transform: "scale(1.75)", color: "#41B6E6", stroke: "#efefef", strokeWidth: "1" }}
      checked={RIGHT_PATIENT === 'Y'} value="Y" onChange={handlePatient}
      />
      <span className="timeout-heading">Right Patient</span>
      <p>Confirm 2 identifiers and allergy status</p>
      <hr/>

      <Checkbox
      icon={<CircleUnchecked />}
      checkedIcon={<CircleCheckedFilled />}
      style={{ transform: "scale(1.75)", color: "#41B6E6", stroke: "#efefef", strokeWidth: "1" }}
      checked={RIGHT_PREP === 'Y'} value="Y" onChange={handlePrep}
      />
      <span className="timeout-heading">Right Prep</span>
      <p>Patient accessible and positioned correctly, bed cleared for intubation, working IV?</p>
      <hr/>

      <Checkbox
      icon={<CircleUnchecked />}
      checkedIcon={<CircleCheckedFilled />}
      style={{ transform: "scale(1.75)", color: "#41B6E6", stroke: "#efefef", strokeWidth: "1" }}
      checked={RIGHT_EQUIPMENT === 'Y'} value="Y" onChange={handleEquipment}
      />
      <span className="timeout-heading">Right Equipment</span>
      <p>SOAP (Suction, Oxygen, Airway, Personel), IV fluid bolus readily available? 2nd medication check?</p>
      <hr/>

      <Checkbox
      icon={<CircleUnchecked />}
      checkedIcon={<CircleCheckedFilled />}
      style={{ transform: "scale(1.75)", color: "#41B6E6", stroke: "#efefef", strokeWidth: "1" }}
      checked={RIGHT_MONITORING === 'Y'} value="Y" onChange={handleMonitoring}
      />
      <span className="timeout-heading">Right Monitoring</span>
      <p>BP cycling frequently, different extremity from pulse ox, pulse ox volume?</p>
      <hr/>

      <Checkbox
      icon={<CircleUnchecked />}
      checkedIcon={<CircleCheckedFilled />}
      style={{ transform: "scale(1.75)", color: "#41B6E6", stroke: "#efefef", strokeWidth: "1" }}
      checked={RIGHT_RESCUE_PLAN === 'Y'} value="Y" onChange={handleRescuePlan}
      />
      <span className="timeout-heading">Right Rescue Plan</span>
      <p>Difficult airway cart/kit and equipment available? Who can we call for assistance?</p>
      <hr/>

      <Checkbox
      icon={<CircleUnchecked />}
      checkedIcon={<CircleCheckedFilled />}
      style={{ transform: "scale(1.75)", color: "#41B6E6", stroke: "#efefef", strokeWidth: "1" }}
      checked={RIGHT_ATTITUDE === 'Y'} value="Y" onChange={handleAttitude}
      />
      <span className="timeout-heading">Right Attitude</span>
      <p>State out loud: If anybody has a concern at any time during the procedure please SPEAK UP.</p>
      <hr/>

      { showGreenDiv ? 
        <div id="greendiv" className="ready-to-intubate">
          <div className="GreenIntubation checklistGreen">
            <input type="checkbox" checked readOnly id="dummy" /><label htmlFor="dummy"></label><h2>Timeout saved successfully</h2>
          </div>
        </div> 
      : null }

      {(RIGHT_PLAN === 'Y' && RIGHT_PROTECTION === 'Y' && RIGHT_PATIENT === 'Y' && RIGHT_PREP === 'Y' && RIGHT_EQUIPMENT === 'Y' && RIGHT_MONITORING === 'Y' && RIGHT_RESCUE_PLAN === 'Y' && RIGHT_ATTITUDE === 'Y') && (
        <div>
        <div className="align-center custom-error">{helperErrorText}</div>
        <div id="two-buttons">
          <button type="submit" className="intubate-btn" id="savetimeout" onClick={e => planForm.current.buttonId=e.target.id}>Timeout Complete. Proceed</button>
        </div>
        <div className="pink-note">Reminder: Complete team debrief after intubation procedure.</div></div>
      )}
      {(RIGHT_PLAN === '' || RIGHT_PROTECTION === '' || RIGHT_PATIENT === '' || RIGHT_PREP === '' || RIGHT_EQUIPMENT === '' || RIGHT_MONITORING === '' || RIGHT_RESCUE_PLAN === '' || RIGHT_ATTITUDE === '') && (
        <div>
        <div className="align-center custom-error">{helperErrorText}</div>
        <div id="two-buttons">
          <button type="submit" className="intubate-btn" id="savetimeout" onClick={e => planForm.current.buttonId=e.target.id}>Save Timeout Progress</button>
        </div>
        <div className="pink-note">Reminder: Complete team debrief after intubation procedure.</div></div>
      )}

      </div>
      </form>

    </div> 
  );
}

export default Timeout;
